import React, {FC, useEffect, useState} from "react"
import {
    GoogleMap,
    InfoWindow,
    Marker,
    withGoogleMap,
    withScriptjs
} from "react-google-maps"
import { graphql, useStaticQuery } from "gatsby"
import useMediaQuery from "@hooks/useMediaQuery"
import {
    InfoWindowContent, Tag, Filter, FilterOption
} from "./styles"

const EventMap: FC<{location: Location}> = ({ location }) => {
    const isMobile = useMediaQuery("(max-width: 768px)")
    const data = useStaticQuery(graphql`
        {
            allGooglePlayUnifiedEventsSheet (
                filter: {longitude: {ne: null}, latitude: {ne: null}}
            ) {
                nodes {
                    date
                    type
                    postalCode
                    city
                    address
                    locatie
                    latitude
                    longitude
                    url
                }
            }
        }
    `)

    const [isOpen, setIsOpen] = useState(null)
    const [filterValue, setFilterValue] = useState("")

    const markers = data.allGooglePlayUnifiedEventsSheet.nodes
    // allTypes needs to be uppercase to have the right value for the filter
    const allTypes = markers.map((m) => { return m.type.toUpperCase() })
    const options = [...new Set(allTypes)]

    useEffect(() => {
        if (location.pathname.includes("club")) {
            return setFilterValue("CLUB")
        } if (location.pathname.includes("school")) {
            return setFilterValue("SCHOOL")
        }
    }, [])

    const filteredMarkers = markers.filter((obj) => {
        return filterValue !== "" ? obj.type === filterValue : true
    })

    return <>
        { options && <div>
            <Filter>
                {options?.map((option) => (
                    <FilterOption
                        active={filterValue === option}
                        onClick={() => (
                            option !== filterValue ? setFilterValue(option)
                                : setFilterValue("")
                        )}
                    >
                        {option}
                    </FilterOption>
                ))}
            </Filter>
        </div>}
        <GoogleMap
            options={{
                disableDefaultUI: true,
                zoomControl: true
            }}
            defaultZoom={isMobile ? 8 : 9}
            defaultCenter={{ lat: 52.132633, lng: 5.291266 }}
        >
            {filteredMarkers?.map((marker, index) => (
                <Marker
                    icon={{
                        scaledSize: new google.maps.Size(43, 60),
                        url: marker.type === "SCHOOL"
                            ? "/icons/educatie-marker.svg"
                            : (marker.type === "CLUB"
                                ? "/icons/club-marker.svg"
                                : "/icons/challenge-marker.svg")
                    }}
                    key={index}
                    position={{ lat: parseFloat(marker.latitude), lng: parseFloat(marker.longitude) }}
                    onClick={() => setIsOpen(index)}
                >
                    {isOpen === index && <InfoWindow onCloseClick={() => setIsOpen(null)}>
                        <InfoWindowContent>
                            <Tag>
                                #
                                {marker.type === "SCHOOL"
                                    ? "OPSCHOOL"
                                    : (marker.type === "CLUB"
                                        ? "OPDECLUB"
                                        : "CHALLENGE")}
                            </Tag>
                            <p>
                                {marker.date}
                                <br />
                                {marker.locatie}
                                <br />
                                {marker.address}
                                <br />
                                {marker.postalCode}
                                {" "}
                                {marker.city}
                                <br />
                                {marker?.url && (marker?.url !== "#")
                                    && <a href={marker?.url}>lees meer..</a>}
                            </p>
                        </InfoWindowContent>
                    </InfoWindow>}
                </Marker>
            ))}
        </GoogleMap>
    </>
}

export default withScriptjs(withGoogleMap(EventMap))
